import { PageMessage } from '@change-corgi/design-system-legacy/components/alerts';

import { usePageBanner } from './hooks/usePageBanner';

// Currently this banner is failing separation of concerns because it depends on the
// set_password page to set the query param
export function PageBanner() {
	const {
		data: { message },
		actions: { closeBanner },
	} = usePageBanner();

	if (!message) {
		return null;
	}

	return (
		<PageMessage
			role="alert"
			message={message}
			severity="success"
			data-testid="start-a-petition-success-banner"
			data-qa="start-a-petition-success-banner"
			dismissable
			onClose={closeBanner}
		/>
	);
}
